import { render, staticRenderFns } from "./COM_Header.vue?vue&type=template&id=390a95eb&"
import script from "./COM_Header.vue?vue&type=script&lang=js&"
export * from "./COM_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390a95eb')) {
      api.createRecord('390a95eb', component.options)
    } else {
      api.reload('390a95eb', component.options)
    }
    module.hot.accept("./COM_Header.vue?vue&type=template&id=390a95eb&", function () {
      api.rerender('390a95eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/COM_Header.vue"
export default component.exports